module.exports = __webpack_public_path__ + "static/img/policeOut.a5b10b3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/policeOut.png
// module id = bd7L
// module chunks = 208